<script>
import * as Sentry from '@sentry/vue'
import Utils from '@/util'
import EventBus from '@/eventBus'
import GetDataPresentationDetailUtils from '@/utils/GetDataPresentationDetailUtils'
import ApiTemplate from '@/api/template'

import PresentationSharingView from '@/components-v2/presentation-editor/PresentationSharingView.vue'

export default {
  name: 'TemplateView',
  extends: PresentationSharingView,
  methods: {
    async getDataPresentationDetail() {
      let { id: presentationId } = this.$route.params

      if (Utils.getShareCodeFromSlug(presentationId) !== null) {
        presentationId = Utils.getShareCodeFromSlug(presentationId)
      }

      try {
        const respBody = await ApiTemplate.getTemplate(presentationId)

        await this.getPresentationAttributeAction(respBody?.id)
        await this.handleDataPresentationDetail({
          body: respBody,
        })

        const { preview: isPreviewPresentation } = this.$route.query

        if (isPreviewPresentation) {
          this.$store.state.isPreview = true
        }

        EventBus.$emit('updateLastSlide')
      } catch (err) {
        Sentry.captureException(err)
        GetDataPresentationDetailUtils
          .handleGetDataPresentationDetailFailed(err, this, presentationId)
      }
    },
  },
}
</script>
